import { colorBlue500, colorGray100 } from '@amzn/meridian-tokens/base/color';
import Column from '@amzn/meridian/column/column';
import Heading from '@amzn/meridian/heading/heading';
import Pie from '@amzn/meridian/pie/pie';
import Row from '@amzn/meridian/row/row';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OMWeeklyCoachingCompletionPercentage } from '../../Types/CoachingStats';

export interface OMLevelCoachingCompletionRatesProps {
  monthlyCoachingCompletionPercentage: number;
  weeklyCoachingCompletionPercentages: OMWeeklyCoachingCompletionPercentage[];
}

const OMLevelCoachingCompletionRates: React.FC<
  OMLevelCoachingCompletionRatesProps
> = ({
  monthlyCoachingCompletionPercentage,
  weeklyCoachingCompletionPercentages,
}): React.ReactElement => {
  if (monthlyCoachingCompletionPercentage > 100) {
    monthlyCoachingCompletionPercentage = 100;
  }
  weeklyCoachingCompletionPercentages.forEach(
    weeklyCoachingCompletionPercentage =>
      weeklyCoachingCompletionPercentage.percentage > 100
        ? (weeklyCoachingCompletionPercentage.percentage = 100)
        : weeklyCoachingCompletionPercentage.percentage
  );
  return (
    <Row
      widths={['40%', '20%', '20%', '20%']}
      spacingInset='300'
      height={'190px'}
      alignmentVertical='top'
    >
      <Column width={'40%'} alignmentVertical='top'>
        <Row widths={['70%', '30%']}>
          <Column height={'10px'} alignmentHorizontal='start'>
            <Heading type='b200' level={4}>
              <b>
                <FormattedMessage
                  id='cs_perfportal_coaching_page_om_aggregated_data_weekly_coaching'
                  defaultMessage='Weekly coaching'
                />
              </b>
            </Heading>
          </Column>
          <Column height={'10px'} alignmentHorizontal='end'>
            <Heading type='b200' level={4}>
              <b>
                <FormattedMessage
                  id='cs_perfportal_coaching_page_om_aggregated_data_completed'
                  defaultMessage='Completion'
                />
              </b>
            </Heading>
          </Column>
        </Row>
        {weeklyCoachingCompletionPercentages.map(
          (
            weeklyPercentage: OMWeeklyCoachingCompletionPercentage,
            index: number
          ) => (
            <>
              <Row
                key={index}
                widths={['70%', '30%']}
                spacingInset='300'
                height={'6px'}
              >
                <Column alignmentHorizontal='start'>
                  <Heading type='b200' level={4} alignment='start'>
                    <FormattedMessage
                      id='cs_perfportal_coaching_page_om_aggregated_data_week'
                      defaultMessage={`Week {weekNum}`}
                      values={{
                        weekNum: weeklyPercentage.weekNum,
                      }}
                    />
                  </Heading>
                </Column>
                <Column alignmentHorizontal='end'>
                  <Heading type='b200' level={4}>
                    <FormattedMessage
                      id='cs_perfportal_coaching_page_om_aggregated_data_weekly_percentage'
                      defaultMessage={'{percentage}%'}
                      values={{
                        percentage: weeklyPercentage.percentage,
                      }}
                    />
                  </Heading>
                </Column>
              </Row>
            </>
          )
        )}
      </Column>
      <Column width={'20%'} alignmentHorizontal='end' alignmentVertical='top'>
        <Pie
          width={60}
          key={monthlyCoachingCompletionPercentage}
          data={[
            {
              value: monthlyCoachingCompletionPercentage,
              color: colorBlue500,
            },
            {
              value: 100 - monthlyCoachingCompletionPercentage,
              color: colorGray100,
            },
          ]}
          donutRatio={0.4}
        />
      </Column>
      <Column width={'10%'}>
        <Heading level={3} type='h300'>
          {`${monthlyCoachingCompletionPercentage}%`}
        </Heading>
        <Row width={'150px'}>
          <FormattedMessage
            id='cs_perfportal_coaching_page_monthly_coaching_completion'
            defaultMessage='Monthly coaching completion'
          />
        </Row>
      </Column>
    </Row>
  );
};

export default OMLevelCoachingCompletionRates;
